export const errorCodeToText = (errCode: string | null) => {
  if (!errCode) {
    return 'טרם התבצעה פעולה';
  }
  switch (errCode) {
    case '000':
      return 'מאושר';
    case '001':
      return 'כרטיס חסום';
    case '002':
      return 'גנוב - החרם כרטיס';

    case '003':
      return 'התקשר לחברת האשראי';
    case '004':
      return 'העסקה לא אושרה';
    case '005':
      return 'כרטיס מזוייף - החרם';
    case '006':
      return 'CVV2 שגוי - דחה עסקה';
    case '007':
      return 'CAVV/UCAF שגוי - דחה עסקה';
    case '008':
      return 'AVS שגוי - דחה עסקה';
    case '009':
      return 'דחייה - נתק בתקשורת';
    case '010':
      return 'אישור חלקי';
    case '011':
      return 'דחה עסקה: חוסר בנקודות/כוכבים/מיילים/הטבה אחרת';
    case '012':
      return 'כרטיס לא מורשה במסוף';
    case '013':
      return 'דחה בקשה - קוד יתרה שגוי';
    case '014':
      return 'דחייה - כרטיס לא משוייך לרשת';
    case '015':
      return 'דחה עסקה: הכרטיס אינו בתוקף';
    case '016':
      return 'דחייה - אין הרשאה לסוג מטבע';
    case '017':
      return 'דחייה - אין הרשאה לסוג אשראי בעסקה';
    case '026':
      return 'CVV או ID שגוי - דחה עסקה';
    case '041':
      return 'חובת יציאה לשאילתא בגין תקרה בלבד (פרמטר j2)';
    case '042':
      return 'חובת יציאה לשאילתא לא רק בגין תקרה (פרמטר j2)';
    case '051':
      return 'חסר קובץ ווקטור 1';
    case '052':
      return 'חסר קובץ ווקטור 4';
    case '053':
      return 'חסר קובץ ווקטור 6';
    case '055':
      return 'חסר קובץ ווקטור 11';
    case '056':
      return 'חסר קובץ ווקטור 12';
    case '057':
      return 'חסר קובץ ווקטור 15';
    case '058':
      return 'חסר קובץ ווקטור 18';
    case '059':
      return 'חסר קובץ ווקטור 31';
    case '060':
      return 'חסר קובץ ווקטור 34';
    case '061':
      return 'חסר קובץ ווקטור 41';
    case '062':
      return 'חסר קובץ ווקטור 44';
    case '063':
      return 'חסר קובץ ווקטור 64';
    case '064':
      return 'חסר קובץ ווקטור 80';
    case '065':
      return 'חסר קובץ ווקטור 81';
    case '066':
      return 'חסר קובץ ווקטור 82';
    case '067':
      return 'חסר קובץ ווקטור 83';
    case '068':
      return 'חסר קובץ ווקטור 90';
    case '069':
      return 'חסר קובץ ווקטור 91';
    case '070':
      return 'חסר קובץ ווקטור 92';
    case '071':
      return 'חסר קובץ ווקטור 93';
    case '073':
      return 'חסר קובץ PARAM_3_1';
    case '074':
      return 'חסר קובץ PARAM_3_2';
    case '075':
      return 'חסר קובץ PARAM_3_3';
    case '076':
      return 'חסר קובץ PARAM_3_4';
    case '077':
      return 'חסר קובץ PARAM_361';
    case '078':
      return 'חסר קובץ PARAM_363';
    case '079':
      return 'חסר קובץ PARAM_364';
    case '080':
      return 'חסר קובץ PARAM_61';
    case '081':
      return 'חסר קובץ PARAM_62';
    case '082':
      return 'חסר קובץ PARAM_63';
    case '083':
      return 'חסר קובץ CEIL_41';
    case '084':
      return 'חסר קובץ CEIL_42';
    case '085':
      return 'חסר קובץ CEIL_43';
    case '086':
      return 'חסר קובץ CEIL_44';
    case '087':
      return 'חסר קובץ DATA';
    case '088':
      return 'חסר קובץ JENR';
    case '089':
      return 'חסר קובץ Start';
    case '101':
      return 'חסרה כניסה בוקטור 1';
    case '103':
      return 'חסרה כניסה בוקטור 4';
    case '104':
      return 'חסרה כניסה בוקטור 6';
    case '106':
      return 'חסרה כניסה בוקטור 11';
    case '107':
      return 'חסרה כניסה בוקטור 12';
    case '108':
      return 'חסרה כניסה בוקטור 15';
    case '110':
      return 'חסרה כניסה בוקטור 18';
    case '111':
      return 'חסרה כניסה בוקטור 31';
    case '112':
      return 'חסרה כניסה בוקטור 34';
    case '113':
      return 'חסרה כניסה בוקטור 41';
    case '114':
      return 'חסרה כניסה בוקטור 44';
    case '116':
      return 'חסרה כניסה בוקטור 64';
    case '117':
      return 'חסרה כניסה בוקטור 81';
    case '118':
      return 'חסרה כניסה בוקטור 82';
    case '119':
      return 'חסרה כניסה בוקטור 83';
    case '120':
      return 'כרטיס לא קיים - שגיאה בהקלדת כרטיס';
    case '121':
      return 'סולק לא קיים - נא לבצע שידור לצורך עדכון פרמטרים ווקטורים';
    case '122':
      return 'מותג לא קיים - נא לבצע שידור לצורך עדכון פרמטרים ווקטורים';
    case '123':
      return 'מנפיק לא קיים - נא לבצע שידור לצורך עדכון פרמטרים ווקטורים';
    case '141':
      return 'אין אישור לעבודה עם המותג הזה - כרטיס ישראלי';
    case '142':
      return 'אין אישור לעבודה עם המותג הזה - כרטיס תייר';
    case '143':
      return 'אין אישור לעבודה עם כרטיס המועדון - כרטיס של ישראכרט';
    case '144':
      return 'אין אישור לעבודה עם כרטיס המועדון - כרטיס של MAX';
    case '145':
      return 'אין אישור לעבודה עם כרטיס המועדון - כרטיס של כאל';
    case '146':
      return 'אין אישור לעבודה עם המותג פרטי';
    case '147':
      return 'חסרה כניסה בקובץ תקרות לכרטיסים ישראלים שאינם PL0 שיטה 4.2';
    case '148':
      return 'חסרה כניסה בקובץ תקרות לכרטיסים ישראלים שאינם PL1 שיטה 4.3';
    case '149':
      return 'חסרה כניסה בקובץ תקרות לכרטיסי תייר 4.4';
    case '150':
      return 'חסרה כניסה בקובץ כרטיסים תקפים - ישראכרט';
    case '151':
      return 'חסרה כניסה בקובץ כרטיסים תקפים - כאל';
    case '152':
      return 'חסרה כניסה בקובץ כרטיסים תקפים - מנפיק עתידי';
    case '182':
      return 'שגיאה בערכי וקטור 4';
    case '183':
      return 'שגיאה בערכי וקטור 6/12';
    case '186':
      return 'שגיאה בערכי וקטור 18';
    case '187':
      return 'שגיאה בערכי וקטור 34';
    case '188':
      return 'שגיאה בערכי וקטור 64';
    case '190':
      return 'שגיאה בערכי וקטור 90';
    case '191':
      return 'נתונים לא תקינים בוקטור הרשאות מנפיק';
    case '192':
      return 'נתונים לא ולידים בסט הפרמטרים';
    case '193':
      return 'נתונים לא ולידים בקובץ פרמטרים ברמת מסוף';
    case '300':
      return 'אין הרשאה לסוג עסקה - הרשאת סולק';
    case '301':
      return 'אין הרשאה למטבע - הרשאת סולק';
    case '303':
      return 'אין הרשאת סולק לביצוע עסקה כאשר הכרטיס לא נוכח';
    case '304':
      return 'אין הרשאה לאשראי - הרשאת סולק';
    case '308':
      return 'אין הרשאה להצמדה - הרשאת סולק';
    case '309':
      return 'אין הרשאת סולק לאשראי במועד קבוע';
    case '310':
      return 'אין הרשאה להקלדת מספר אישור מראש';
    case '311':
      return 'אין הרשאה לבצע עסקאות לקוד שרות 587';
    case '312':
      return 'אין הרשאת סולק לאשראי דחוי';
    case '313':
      return 'אין הרשאת סולק להטבות';
    case '314':
      return 'אין הרשאת סולק למבצעים';
    case '315':
      return 'אין הרשאת סולק לקוד מבצע ספציפי';
    case '316':
      return 'אין הרשאת סולק לעסקת טעינה';
    case '317':
      return 'אין הרשאת סולק לטעינה/פריקה בקוד אמצעי התשלום בשילוב קוד מטבע';
    case '318':
      return 'אין הרשאת סולק למטבע בסוג אשראי זה';
    case '319':
      return 'אין הרשאת סולק לטיפ';
    case '321':
      return 'אין לכרטיס נטען הרשאה לביצוע בקשה לאישור';
    case '322':
      return 'אין הרשאה מתאימה לביצוע בקשה לאישור ללא עסקה';
    case '323':
      return 'אין הרשאה לביצוע אישור בקשה יזומה ע"י קמעונאי';
    case '341':
      return 'אין הרשאה לעסקה - הרשאת מנפיק';
    case '342':
      return 'אין הרשאה למטבע - הרשאת מנפיק';
    case '343':
      return 'אין הרשאת מנפיק לביצוע עסקה כאשר הכרטיס לא נוכח';
    case '344':
      return 'אין הרשאה לאשראי - הרשאת מנפיק';
    case '348':
      return 'אין הרשאה לביצוע אישור בקשה יזומה ע"י קמעונאי (מנפיק)';
    case '349':
      return 'J5 אין הרשאה מתאימה לביצוע בקשה לאישור ללא עסקה';
    case '350':
      return 'אין הרשאת מנפיק להטבות';
    case '351':
      return 'אין הרשאת מנפיק לאשראי דחוי';
    case '352':
      return 'אין הרשאת מנפיק לעסקת טעינה';
    case '353':
      return 'אין הרשאת מנפיק לטעינה/פריקה בקוד אמצעי התשלום';
    case '354':
      return 'אין הרשאת מנפיק למטבע בסוג אשראי זה';
    case '381':
      return 'אין הרשאה לבצע עסקת contactless מעל סכום מרבי';
    case '382':
      return 'במסוף המוגדר כשרות עצמי ניתן לבצע רק עסקאות בשירות עצמי';
    case '384':
      return 'מסוף מוגדר כרב-ספק/מוטב - חסר מספר ספק/מוטב';
    case '385':
      return 'במסוף המוגדר כמסוף סחר אלקטרוני חובה להעביר ECI';
    case '401':
      return 'מספר התשלומים גדול מערך שדה מספר תשלומים מקסימלי';
    case '402':
      return 'מספר התשלומים קטן מערך שדה מספר תשלומים מינימלי';
    case '403':
      return 'סכום העסקה קטן מערך שדה סכום מינמלי לתשלום';
    case '404':
      return 'לא הוזן שדה מספר תשלומים';
    case '405':
      return 'חסר נתון סכום תשלום ראשון/קבוע';
    case '406':
      return 'סה"כ סכום העסקה שונה מסכום תשלום ראשון + סכום תשלום קבוע × מספר תשלומים';
    case '408':
      return 'ערוץ 2 קצר מ-37 תווים';
    case '410':
      return 'דחיה מסיבת dcode';
    case '414':
      return 'בעסקה עם חיוב בתאריך קבוע הוכנס תאריך מאוחר משנה מבצוע העסקה';
    case '415':
      return 'הוזנו נתונים לא תקינים';
    case '416':
      return 'תאריך תוקף לא במבנה תקין';
    case '417':
      return 'מספר מסוף אינו תקין';
    case '418':
      return 'חסרים פרמטרים חיוניים';
    case '419':
      return 'שגיאה בהעברת מאפיין clientInputPan';
    case '420':
      return 'מספר כרטיס לא ולידי - במצב של הזנת ערוץ 2 בעסקה ללא כרטיס נוכח';
    case '421':
      return 'שגיאה כללי - נתונים לא ולידים';
    case '422':
      return 'שגיאה בבנית מסר ISO';
    case '424':
      return 'שדה לא נומרי';
    case '425':
      return 'רשומה כפולה';
    case '426':
      return 'הסכום הוגדל לאחר ביצוע בדיקות אשראית';
    case '428':
      return 'חסר קוד שרות בכרטיס';
    case '429':
      return 'כרטיס אינו תקף לפי קובץ כרטיסים תקפים';
    case '431':
      return 'שגיאה כללית';
    case '432':
      return 'אין הרשאה להעברת כרטיס דרך קורא מגנטי';
    case '433':
      return 'חיוב להעביר ב-PinPad';
    case '434':
      return 'אסור להעביר כרטיס במכשיר PinPad';
    case '435':
      return 'המכשיר CTL לא מוגדר להעברת כרטיס מגנטי';
    case '436':
      return 'המכשיר CTL EMV לא מוגדר להעברת כרטיס';
    case '439':
      return 'אין הרשאה לסוג אשראי לפי סוג עסקה';
    case '440':
      return 'כרטיס תייר אינו מורשה לסוג אשראי זה';
    case '441':
      return 'אין הרשאה לביצוע סוג עסקה - כרטיס קיים בוקטור 80';
    case '442':
      return 'אין לבצע Stand-in לאימות אישור לסולק זה';
    case '443':
      return 'לא ניתן לבצע עסקת ביטול - כרטיס לא נמצא בקובץ תנועות הקיים במסוף';
    case '445':
      return 'בכרטיס חיוב מיידי ניתן לבצע אשראי חיוב מיידי בלבד';
    case '447':
      return 'מספר כרטיס שגוי';
    case '448':
      return 'חיוב להקליד כתובת לקוח (מיקוד, מספר בית ועיר)';
    case '449':
      return 'חיוב להקליד מיקוד';
    case '450':
      return 'קוד מבצע מחוץ לתחום - צריך להיות בתחום 1-12';
    case '451':
      return 'שגיאה במהלך בנית רשומת עסקה';
    case '452':
      return 'בעסקת טעינה/פריקה/בירור יתרה חיוב להזין שדה קוד אמצעי תשלום';
    case '453':
      return 'אין אפשרות לבטל עסקת פריקה 7.9.3';
    case '455':
      return 'לא ניתן לבצע עסקת חיוב מאולצת כאשר נדרשת בקשה לאישור (למעט תקרות)';
    case '456':
      return 'כרטיס נמצא בקובץ תנועות עם קוד תשובה "החרם כרטיס"';
    case '457':
      return 'בכרטיס חיוב מיידי מותרת עסקת חיוב רגילה/זיכוי/ביטול';
    case '458':
      return 'קוד מועדון לא בתחום';
    case '470':
      return 'בעסקת הו"ק סכום התשלומים גבוה משדה סכום העסקה';
    case '471':
      return 'בעסקת הו"ק מספר תשלום תורן גדול מסה"כ מספר התשלומים';
    case '472':
      return 'בעסקת חיוב עם מזומן חיוב להזין סכום במזומן';
    case '473':
      return 'בעסקת חיוב עם מזומן סכום המזומן צריך להיות קטן מסכום העסקה';
    case '474':
      return 'עסקת איתחול בהוראת קבע מחייבת פרמטר J5';
    case '475':
      return 'עסקת הו"ק מחייבת אחד מהשדות: מספר תשלומים או סכום כולל';
    case '476':
      return 'עסקת תורן בהוראת קבע מחייבת שדה מספר תשלום';
    case '477':
      return 'עסקת תורן בהוראת קבע מחייבת מספר מזהה של עסקת איתחול';
    case '478':
      return 'עסקת תורן בהוראת קבע מחייבת מספר אישור של עסקת איתחול';
    case '479':
      return 'עסקת תורן בהוראת קבע מחייבת שדות תאריך וזמן עסקת איתחול';
    case '480':
      return 'חסר שדה מאשר עסקת מקור';
    case '481':
      return 'חסר שדה מספר יחידות כאשר העסקה מתבצעת בקוד אמצעי תשלום השונה ממטבע';
    case '482':
      return 'בכרטיס נטען מותרת עסקת חיוב רגילה/זיכוי/ביטול/פריקה/טעינה/בירור יתרה';
    case '483':
      return 'עסקה עם כרטיס דלק במסוף דלק - חיוב להזין מספר רכב';
    case '484':
      return 'מספר רכב המוקלד שונה ממספר הרכב הצרוב / מספר בנק שונה מ-012';
    case '485':
      return 'מספר רכב קצר מ-6 ספרות (לאומי קארד)';
    case '486':
      return 'ישנה חובת הקלדת קריאת מונה (לאומי קארד)';
    case '487':
      return 'רק במסוף המוגדר כדלק דו שלבי ניתן להשתמש בעדכון אובליגו';
    case '489':
      return 'בכרטיס דלקן מותרת עסקת חיוב רגילה בלבד';
    case '490':
      return 'בכרטיסי דלק/דלקן/דלק מועדון ניתן לבצע עסקאות רק במסופי דלק';
    case '491':
      return 'עסקה הכוללת המרה חייבת להכיל את כל שדות ההמרה';
    case '492':
      return 'אין המרה על עסקאות שקל/דולר';
    case '493':
      return 'בעסקה הכוללת הטבה חיוב שיהיו רק אחד מהשדות: סכום הנחה/מספר יחידות/% ההנחה';
    case '494':
      return 'מספר מסוף שונה';
    case '495':
      return 'אין הרשאת fallback';
    case '496':
      return 'לא ניתן להצמיד אשראי השונה מאשראי קרדיט/תשלומים';
    case '497':
      return 'לא ניתן להצמיד לדולר/מדד במטבע השונה משקל';
    case '498':
      return 'כרטיס ישראכרט מקומי - הספרטור צריך להיות בפוזיציה 18';
    case '500':
      return 'העסקה הופסקה על ידי המשתמש';
    case '504':
      return 'חוסר התאמה בין שדה מקור נתוני הכרטיס לשדה מספר כרטיס';
    case '505':
      return 'ערך לא חוקי בשדה סוג עסקה';
    case '506':
      return 'ערך לא חוקי בשדה ECI';
    case '507':
      return 'סכום העסקה בפועל גבוה מהסכום המאושר';
    case '509':
      return 'שגיאה במהלך כתיבה לקובץ תנועות';
    case '512':
      return 'לא ניתן להכניס אישור שהתקבל ממענה קולי לעסקה זו';
    case '551':
      return 'מסר תשובה אינו מתאים למסר הבקשה';
    case '552':
      return 'שגיאה בשדה 55';
    case '553':
      return 'התקבלה שגיאה מהטנדם';
    case '554':
      return 'במסר התשובה חסר שדה mcc_18';
    case '555':
      return 'במסר התשובה חסר שדה response_code_25';
    case '556':
      return 'במסר התשובה חסר שדה rrn_37';
    case '557':
      return 'במסר התשובה חסר שדה comp_retailer_num_42';
    case '558':
      return 'במסר התשובה חסר שדה auth_code_43';
    case '559':
      return 'במסר התשובה חסר שדה f39_response_39';
    case '560':
      return 'במסר התשובה חסר שדה authorization_no_38';
    case '561':
      return 'במסר התשובה חסר/ריק שדה additional_data solek_auth_no';
    case '562':
      return 'במסר התשובה חסר אחד מהשדות: conversion_amount_06, conversion_rate_09, conversion_currency_51';
    case '563':
      return 'ערך השדה auth_code_43 אינו מתאים למספרי האישור שהתקבלו';
    case '564':
      return 'במסר התשובה חסר/ריק שדה cashback_amount';
    case '565':
      return 'אי-התאמה בין שדה 25 לשדה 43';
    case '566':
      return 'במסוף המוגדר כתומך בדלק דו-שלבי יש חובה להחזיר שדות 90, 119';
    case '567':
      return 'שדות 25, 127 לא תקינים במסר עידכון אובליגו במסוף המוגדר כדלק דו-שלבי';
    case '598':
      return 'שגיאה בקובץ חסומים (ERROR_IN_NEG_FILE)';
    case '599':
      return 'שגיאה כללית';
    case '700':
      return 'עסקה נדחתה על ידי מכשיר PinPad';
    case '701':
      return 'שגיאה במכשיר PinPad';
    case '702':
      return 'יציאת COM לא תקינה';
    case '703':
      return 'שגיאת עסקה ב-PinPad (PINPAD_TransactionError)';
    case '704':
      return 'עסקה בוטלה ב-PinPad (PINPAD_TransactionCancelled)';
    case '705':
      return 'המשתמש ביטל (PINPAD_UserCancelled)';
    case '706':
      return 'פסק זמן - משתמש (PINPAD_UserTimeout)';
    case '707':
      return 'המשתמש הסיר את הכרטיס (PINPAD_UserCardRemoved)';
    case '708':
      return 'המשתמש חרג ממספר הניסיונות (PINPAD_UserRetriesExceeded)';
    case '709':
      return 'פסק זמן - PinPad (PINPAD_PINPadTimeout)';
    case '710':
      return 'שגיאת תקשורת PinPad (PINPAD_PINPadCommsError)';
    case '711':
      return 'שגיאת הודעה ב-PinPad (PINPAD_PINPadMessageError)';
    case '712':
      return 'PinPad לא אותחל (PINPAD_PINPadNotInitialized)';
    case '713':
      return 'שגיאת קריאת כרטיס ב-PinPad (PINPAD_PINPadCardReadError)';
    case '714':
      return 'פסק זמן - קורא (PINPAD_ReaderTimeout)';
    case '715':
      return 'שגיאת תקשורת קורא (PINPAD_ReaderCommsError)';
    case '716':
      return 'שגיאת הודעה בקורא (PINPAD_ReaderMessageError)';
    case '717':
      return 'שגיאת הודעה ב-Host (PINPAD_HostMessageError)';
    case '718':
      return 'שגיאת הגדרות Host (PINPAD_HostConfigError)';
    case '719':
      return 'שגיאת מפתח Host (PINPAD_HostKeyError)';
    case '720':
      return 'שגיאת התחברות Host (PINPAD_HostConnectError)';
    case '721':
      return 'שגיאת שידור Host (PINPAD_HostTransmitError)';
    case '722':
      return 'שגיאת קבלה Host (PINPAD_HostReceiveError)';
    case '723':
      return 'פסק זמן Host (PINPAD_HostTimeout)';
    case '724':
      return 'אימות PIN אינו נתמך בכרטיס (PINVerificationNotSupportedByCard)';
    case '725':
      return 'אימות PIN נכשל (PINVerificationFailed)';
    case '726':
      return 'שגיאה בקליטת קובץ config.xml';
    case '730':
      return 'מכשיר אישר עסקה בניגוד להחלטת אשראית';
    case '731':
      return 'כרטיס לא הוכנס';
    case '777':
      return 'תקין, ניתן להמשיך';
    case '998':
      return 'שגיאה בקובץ חסומים';
    // API status codes
    case 'API-001':
      return 'כרטיס חסום';
    case 'API-002':
      return 'כרטיס גנוב';
    case 'API-005':
      return 'כרטיס מזויף';
    case 'API-033':
      return 'כרטיס לא תקין';
    case 'API-036':
      return 'כרטיס פג תוקף';
    case 'API-039':
      return 'ספרת ביקורת של כרטיס לא תקינה';
    case 'API-061':
      return 'כרטיס לא נמצא';
    case 'API-062':
      return 'סוג עסקה לא תקין';
    case 'API-063':
      return 'קוד עסקה לא תקין';
    case 'API-064':
      return 'סוג אשראי לא תקין';
    case 'API-069':
      return 'אורך פס מגנטי קצר מידי';
    case 'API-101':
      return 'אין אישור מחברת האשראי לעבודה';
    case 'API-500':
      return 'מסוף מבצע שידור ו/או מעדכן נתונים - נסה שנית מאוחר יותר';
    case 'API-501':
      return 'שם משתמש ו/או סיסמה לא נכונים - אנא פנה למחלקת תמיכה';
    case 'API-503':
      return 'משתמש נעול - אנא פנה למחלקת תמיכה';
    case 'API-505':
      return 'מסוף חסום - אנא פנה להנהלת חשבונות';
    case 'API-506':
      return 'מספר טוקן לא תקין';
    case 'API-507':
      return 'משתמש לא רשאי לבצע פעולות במסוף זה';
    case 'API-508':
      return 'מבנה תוקף לא תקין - יש להשתמש במבנה MMYY בלבד';
    case 'API-510':
      return 'לא קיים נתונים';
    case 'API-598':
      return 'ערכים נחוצים חסרים או שגויים';
    case 'API-599':
      return 'שגיאה כללית - אנא פנה לתמיכה';
    default:
      return `שגיאה לא מוכרת (קוד: ${errCode})`;
  }
};
